module.exports = __webpack_public_path__ + "img/visu-home@2x.be0a86ed.png";